import { getPresenceStatus } from './presence-derivations.js';
export const MENU_GROUP_ORDER = [
    'online',
    'busy',
    'away',
    'missing',
    'offline',
    'inactive',
];
export const MENU_GROUP_LABELS = {
    online: 'Online',
    busy: 'Busy',
    away: 'Away',
    missing: 'Missing',
    offline: 'Offline',
    inactive: 'Inactive',
};
export function getMenuGroup(tester, ctx) {
    return getPresenceStatus(tester, ctx);
}
/**
 * Bucket a list of testers into the six sidebar groups in one pass.
 *
 * Web's `<PresenceMenu>` and the Discord Activity's `<PresenceRoster>` both
 * need this exact shape, so the grouping lives in shared rather than being
 * reimplemented per-runtime. Iteration order within each bucket is preserved
 * — callers control sort upstream (typically alphabetic by alias from the
 * `/tester/presence` handler) and the grouping does not perturb it.
 */
export function groupTestersByMenuGroup(testers, ctx) {
    return groupTestersByStatus(testers, (t) => getMenuGroup(t, ctx));
}
/**
 * Bucket testers by a caller-supplied status function rather than the default
 * `getMenuGroup`. `buildPresenceSections` uses this to group the non-FM-section
 * remainder with an *on-duty-aware* status (an on-duty FM is derived as an
 * on-shift floor manager even when their static roster fields lag), so a
 * fallen-through Missing FM lands in the Missing bucket — not the Away bucket
 * its stale `scheduleState` would otherwise imply.
 */
export function groupTestersByStatus(testers, statusOf) {
    const groups = {
        online: [],
        busy: [],
        away: [],
        missing: [],
        offline: [],
        inactive: [],
    };
    for (const t of testers) {
        // #4427 — invisible testers don't belong in any sidebar bucket (that's
        // the whole point of "invisible"). The presence handler still surfaces
        // the requesting user's own invisible row so the YOU card can render;
        // skip it here so the same row doesn't get force-bucketed into Offline.
        if (t.availability === 'invisible')
            continue;
        groups[statusOf(t)].push(t);
    }
    return groups;
}
/**
 * First non-whitespace character of an alias, uppercased — for the avatar
 * fallback disc when `avatarUrl` is null. Returns `'?'` when the alias is
 * blank rather than throwing, since this only drives UI presentation; the
 * API contract guarantees a non-empty alias and a thrown error here would
 * crash the entire sidebar over a malformed row.
 */
export function getAliasInitial(alias) {
    const trimmed = alias.trim();
    if (trimmed.length === 0)
        return '?';
    return trimmed.charAt(0).toUpperCase();
}
//# sourceMappingURL=menu-groups.js.map